(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneArchiveImageLoaderWebWorker", [], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneArchiveImageLoaderWebWorker"] = factory();
	else
		root["cornerstoneArchiveImageLoaderWebWorker"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition